<template>
  <div v-if="currentReponse">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 offset-lg-6 col-lg-6">
          <div class="row">
            <div class="col-md-12">
              <table
                class="card table table-sm table-custom-primary table-bordered mb-0"
              >
                <tbody>
                  <tr class="d-flex font-size-17">
                    <td class="col-6 text-custom-primary text-center">
                      Référence réponse :
                      {{ currentReponse.document.reference }}
                    </td>
                    <td class="col-6">
                      Statut :
                      <span v-if="currentReponse.statut > 0">
                        <i
                          class="mdi mdi-checkbox-blank-circle mr-1"
                          :class="{
                            'text-success':
                              currentReponse.statut === 1 ||
                              currentReponse.statut === 2,
                          }"
                        ></i>
                        {{ getStatutSourcingReponse(currentReponse.statut) }}
                      </span>
                      <span v-else> ### </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-12 col-lg-6">
          <button
            type="button"
            class="btn btn-secondary mr-4"
            @click.prevent="
              $router.push({ name: listReponseUrl }).catch(() => {})
            "
          >
            Liste des réponses
          </button>
          <button
            v-if="currentReponse.sourcing.statut === 0"
            type="button"
            class="btn btn-custom-primary mr-4"
            @click.prevent="
              $router.push({ name: listReponseUrl + '-create' }).catch(() => {})
            "
          >
            <i class="fas fa-plus"></i>
            Nouvelle réponse
          </button>
          <button
            v-if="
              currentReponse.statut === 0 &&
              currentReponse.sourcing.statut === 0
            "
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="
              $router
                .push({
                  name: listReponseUrl + '-edit',
                  params: { reponseId: currentReponse.id },
                })
                .catch(() => {})
            "
          >
            <i class="fa fa-edit font-size-17"></i> Modifier
          </button>
        </div>
        <div
          class="col-md-12 col-lg-6 text-right"
          v-if="
            currentReponse.statut === 0 && currentReponse.sourcing.statut === 0
          "
        >
          <button
            type="button"
            title="Transformer en demande d'achat"
            class="btn btn-custom-primary mr-4"
            @click.prevent="
              $router
                .push({
                  name: 'achat_demande-create',
                  params: { filter: 's_rp', id: currentReponse.id },
                })
                .catch(() => {})
            "
          >
            <i class="fa fa-share-square font-size-17"></i> Demande d'achat
          </button>

          <button
            type="button"
            title="Transformer en commande"
            class="btn btn-custom-primary"
            @click.prevent="
              $router
                .push({
                  name: 'achat_commande-create',
                  params: { filter: 's_rp', id: currentReponse.id },
                })
                .catch(() => {})
            "
          >
            <i class="fa fa-share-square font-size-17"></i> Commande
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date</span>
                  </td>
                  <td>
                    {{ currentReponse.date }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Fournisseur</span>
                  </td>
                  <td>
                    {{ currentReponse.fournisseur.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Devise</span>
                  </td>
                  <td>
                    {{
                      currentReponse.devise.symbole +
                      ' ( ' +
                      currentReponse.devise.nom +
                      ' )'
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Validité</span>
                  </td>
                  <td>
                    {{ currentReponse.validite }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold">
                      Délai de livraison (en jour)</span
                    >
                  </td>
                  <td>
                    <span v-if="currentReponse.delai_livraison === 0">
                      A la commande</span
                    >
                    <span v-if="currentReponse.delai_livraison > 0">
                      <span v-if="currentReponse.delai_livraison === 1">
                        1 jour
                      </span>
                      <span v-else>
                        {{ currentReponse.delai_livraison }} jours
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentReponse.document.created_by.prenom
                        ? currentReponse.document.created_by.prenom +
                          ' ' +
                          currentReponse.document.created_by.nom
                        : currentReponse.document.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-md-12">
          <table class="card table table-sm">
            <thead>
              <tr class="d-flex">
                <th class="col-5">Article</th>
                <th class="col-2 text-center">Quantité</th>
                <th class="col-2 text-center">Prix HT</th>
                <th class="col-1 text-center">TVA %</th>
                <th class="col-2 text-center">Montant</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in currentReponse.item_lists"
                :key="index"
                class="d-flex"
              >
                <td class="col-5" style="vertical-align: middle">
                  Désignation : {{ item.designation }} <br />
                  Référence : {{ item.reference }} <br />
                </td>

                <td class="col-2 text-center" style="vertical-align: middle">
                  {{ item.quantite + ' ' + item.unite }}
                </td>
                <td class="col-2 text-center" style="vertical-align: middle">
                  {{ item.prix | currency }}
                </td>

                <td class="col-1 text-center" style="vertical-align: middle">
                  {{ item.tva + ' %' }}
                </td>
                <td
                  class="col-2 text-right font-weight-bold font-size-17"
                  style="vertical-align: middle"
                >
                  {{
                    formatWithCurrency(
                      item.quantite * item.prix +
                        (item.tva / 100) * (item.quantite * item.prix),
                      currentReponse.devise.symbole
                    )
                  }}
                </td>
              </tr>
              <tr v-if="currentReponse.item_lists.length === 0" class="d-flex">
                <td colspan="5" class="text-center col-12">Aucune donnée</td>
              </tr>
            </tbody>
            <tfoot class="font-weight-bold font-size-18">
              <tr class="d-flex">
                <td class="text-right col-8">TOTAL HT</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(totalHt, currentReponse.devise.symbole)
                  }}
                </td>
              </tr>
              <tr class="d-flex" v-if="totalTva > 0">
                <td class="text-right col-8">TOTAL TVA</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(totalTva, currentReponse.devise.symbole)
                  }}
                </td>
              </tr>
              <tr class="d-flex" v-if="totalTva > 0">
                <td class="text-right col-8">TOTAL TTC</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(
                      totalHt + totalTva,
                      currentReponse.devise.symbole
                    )
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/achat/sourcing/sourcing-reponse';
export default {
  data() {
    return {
      currentReponse: null,
    };
  },
  computed: {
    listReponseUrl() {
      return this.$route.name.split('-')[0];
    },
    totalHt() {
      return window._.sumBy(
        this.currentReponse.item_lists,
        (item) => item.quantite * item.prix
      );
    },
    totalTva() {
      return window._.sumBy(
        this.currentReponse.item_lists,
        (item) => (item.tva / 100) * (item.quantite * item.prix)
      );
    },
  },
  methods: {
    init() {
      window.axios
        .get(URL.SOURCING_REPONSE + '/' + this.$route.params.reponseId)
        .then((resp) => {
          this.currentReponse = resp.data.sourcing_reponse;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
